<script>
	import Portal from 'svelte-portal';
	export let lang='en', closePanel, checkedRatingVal=0, productCode='';

	let en = lang == 'en';

	const brandText = document.querySelector('.BrandLink') ? document.querySelector('.BrandLink').textContent?.trim() + ' ' : '';	
	const productTitle = document.querySelector('.brand-product-container h1') ? [...document.querySelector('.brand-product-container h1').childNodes]?.at(-1)?.textContent.trim() : '';
	
	let isRecommended = true;
	let addCurrentIndex = 0;
	let formEle;
	let overallRatingVal = checkedRatingVal || 0;
	let errors = {
		rating: '',
		title: '',
		reviewtext: '',
		usernickname: '',
		useremail: '',
		photo: '',
		agreedtotermsandconditions: ''
	}
	let showSuccessScreen = false;

	let isLoading = false;

	const submitHandler = async()=> {
		//doing nothing for now, just preventing default form submission behavior
		try {
			isLoading = true;
			let formData = new FormData(formEle);
            //Bazaarvoice user cookie check
            let bzUserId = getCookie('BV_user_id');

            if(bzUserId) {
                formData.append('user', bzUserId);
            }

			const response = await fetch(`/_api/${lang}/bazaarvoice/reviewSubmit/${productCode}`, {
                method: "POST",
                body: formData
            });

            // display errors if BV sends back error fields
            if (!response.ok) {
                const json = await response.json();
                if (json?.errorFields) displayErrors(json.errorFields);
				isLoading = false;
                scrollToFirstError();
                return;
            }

            // reset form if submission is successfull
			showSuccessScreen = true;
			const panel = document.querySelector('hh-panel')
			if(panel) {
				panel.scrollTo({
					top: 0,
					behavior: "smooth"
				});
			}
            clearErrors();
            clearImages();
            formEle.reset();
			isLoading = false;			

		} catch (error) {
			isLoading = false;
			console.error('Error submitting review:', error);
		}
	}

		// clear form errors
	function clearErrors() {
		errors = {
			rating: '',
			title: '',
			reviewtext: '',
			usernickname: '',
			useremail: '',
			photo: '',
			agreedtotermsandconditions: ''
		}
		//check for dom element and reset selected stars to 0
		let pdpEle = document.querySelectorAll(`.Reviews .reviewstars input`);
		if (pdpEle.length) {
			pdpEle.forEach(el => el.checked = false);
		}
	}
	// display all errors coming from BV
	function displayErrors(errorFields) {
		// remove all error messages before displaying new ones
		clearErrors();

		// add error messages to the fields passed back from BV
		const errorFieldsArray = Object.entries(errorFields);
		errorFieldsArray.forEach(([key, value]) => {
			errors[key] = value.Message;
			// const field = formEle.querySelector(`[name="${key}"]`) || formEle.querySelector(`#${key}`);
			// if (field) {
			// 	const errorMessage = document.createElement('small');
			// 	errorMessage.classList.add('ErrorNote');
			// 	errorMessage.textContent = value.Message;
			// 	field.appendChild(errorMessage);
			// }
		});
	}
	function clearImages() {
		let uploadedImages = formEle.querySelectorAll('.uploaded-image')
		if(uploadedImages.length) {
			uploadedImages.forEach(img => img.remove());
		}
	}

	function imageBoxClick(index) {
        addCurrentIndex = index;
        const input = document.getElementById(`photo-upload-${index}`);
        if (input) input.click();
    }

    function showImage(event) {
        const files = Array.from(event.target.files);
        const file = files[0];
        if (!file || !file.type.startsWith('image/')) return;

        const reader = new FileReader();
        reader.onload = function (e) {
            const uploadBoxes = document.querySelectorAll('.upload-boxes > div');
            const box = uploadBoxes[addCurrentIndex];

            box.querySelectorAll('img:not(.plus):not(.clear-btn)').forEach(img => img.remove());

            const img = document.createElement('img');
            img.src = e.target.result;
			img.classList.add('uploaded-image');
            box.appendChild(img);
        };
        reader.readAsDataURL(file);
    }

    function clearImage(event, index) {
        event.stopPropagation();
        const input = document.getElementById(`photo-upload-${index}`);
        const box = input.closest('.upload-box');

        // Clear the image
        box.querySelectorAll('img:not(.plus):not(.clear-btn)').forEach(img => img.remove());

        // Reset input
        input.value = "";
    }

	function resetForm() {
		formEle.reset();
		isRecommended = false;
		formEle.querySelectorAll('.uploaded-image').forEach(img => img.remove());
	}

	function scrollToFirstError() {
		const firstError = formEle.querySelector('.ErrorNote')?.parentElement;
		if (firstError) {
			firstError.style.scrollMargin= '2rem';
			firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	}

</script>

<Portal target="hh-panel">
	{#if !showSuccessScreen}
		<header>
			<h3>{en ? 'Complete a Review' : 'Terminer une évaluation'}</h3>
			<button class="Button ButtonGhost" on:click|preventDefault={closePanel}>{en ? 'Close' : 'Fermer'}</button>
		</header>

		<p class="product-name"><strong>{brandText}</strong>{productTitle}</p>

		<form bind:this={formEle} on:submit|preventDefault={submitHandler} class="Form">
			<fieldset class="overall-rating">
				<legend><strong>{en ? 'Overall Rating' : 'Évaluations des clients'}*</strong></legend>
				<div class="container">
					<span>{en ? 'Click to rate!' : 'Cliquez pour évaluer!'}</span>
					<div class="reviewstars">
						{#each [5,4,3,2,1] as item}
							<label title={`${item} stars`}><input type="radio" name="rating" value={item} checked={overallRatingVal == item}/>★</label>
						{/each}
					</div>
				</div>
				{#if errors.rating}
					<small class="ErrorNote">{errors.rating}</small>
				{/if}
			</fieldset>
			<fieldset>
				<label for="review-title">
					<strong>{en ? 'Review Title' : 'Titre de l\'évaluation'}*</strong>
				</label>
				<input type="text" id="review-title" name="title"  />
				{#if errors.title}
					<small class="ErrorNote">{errors.title}</small>
				{/if}
			</fieldset>
			<fieldset>
				<label for="review-content">
					<strong>{en ? 'Review' : 'Révision'}*</strong>
				</label>
				<textarea id="review-content" name="reviewtext" ></textarea>
				{#if errors.reviewtext}
					<small class="ErrorNote">{errors.reviewtext}</small>
				{/if}
			</fieldset>
			<fieldset class="recommendation">
				<input type="checkbox" id="review-is-recommended" name="isRecommended" checked={isRecommended} hidden/>
				<label for="review-is-recommended">
					<strong>{en ? 'Would you recommend this product to a friend?' : 'Recommanderiez-vous ce produit à un ami?'}</strong>
				</label>
				<div class="btn-group">
					<button type="button" class="Button" class:ButtonPrimary={isRecommended} class:ButtonSecondary={!isRecommended} on:click={()=> isRecommended=true}>{en ? 'Yes' : 'Oui'}</button>
					<button type="button" class="Button" class:ButtonPrimary={!isRecommended} class:ButtonSecondary={isRecommended} on:click={()=> isRecommended=false}>{en ? 'No' : 'Non'}</button>
				</div>
			</fieldset>

			<fieldset class="fieldsetInline">
				<label for="review-nickname">
					<strong>{en ? 'Nickname' : 'Surnom'}*</strong>
				</label>
				<div>
					<input type="text" id="review-nickname" name="usernickname"  />
					{#if errors.usernickname}
						<small class="ErrorNote">{errors.usernickname}</small>
					{/if}
				</div>
			</fieldset>
			<fieldset class="fieldsetInline">
				<label for="review-email">
					<strong>{en ? 'Email' : 'Courriel'}*</strong>
				</label>
				<div>
					<input type="text" id="review-email" name="useremail"  />
					{#if errors.useremail}
						<small class="ErrorNote">{errors.useremail}</small>
					{/if}
				</div>
			</fieldset>
			<fieldset class="fieldsetInline">
				<label for="review-userLocation">
					<strong>{en ? 'Location' : 'Emplacement'}</strong>
				</label>
				<div>
					<input type="text" id="review-userLocation" name="userlocation" />
				</div>
			</fieldset>
			<fieldset class="fieldsetInline">
				<label for="quality-rating-set">
					<strong>{en ? 'Quality' : 'Qualité'}</strong>
				</label>
				<div>
					<div class="reviewstars" id="quality-rating-set">
						{#each [5,4,3,2,1] as item}
							<label title={`${item} stars`}><input type="radio" name="rating_Quality" value={item} />★</label>
						{/each}
					</div>
				</div>
			</fieldset>
			<fieldset class="fieldsetInline">
				<label for="value-rating-set">
					<strong>{en ? 'Value' : 'Valeur'}</strong>
				</label>
				<div>
					<div class="reviewstars" id="value-rating-set">
						{#each [5,4,3,2,1] as item}
							<label title={`${item} stars`}><input type="radio" name="rating_Value" value={item} />★</label>
						{/each}
					</div>
				</div>
			</fieldset>
			<fieldset class="fieldsetInline">
				<label for="durability-rating-set">
					<strong>{en ? 'Durability' : 'Durabilité'}</strong>
				</label>
				<div>
					<div class="reviewstars" id="durability-rating-set">
						{#each [5,4,3,2,1] as item}
							<label title={`${item} stars`}><input type="radio" name="rating_Durability" value={item} />★</label>
						{/each}
					</div>
				</div>
			</fieldset>

			<fieldset>
				<p><strong>{en ? 'Add Images' : 'Ajouter des images'}</strong> {en ? '(maximum of 6)' : '(maximum de 6)'}</p>
				<div class="upload-boxes">
					{#each Array(6) as _, i}
					
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
						<div class="upload-box" on:click={() => imageBoxClick(i)} tabindex="0">
							<!-- svelte-ignore a11y-img-redundant-alt -->
							<img 
								on:click={(event) => clearImage(event, i)}
								on:keydown={(event) => { if (event.key === 'Enter' || event.key === ' ') clearImage(event, i); }}
								src="https://homehardware.sirv.com/hh/icons/icon-crossed-black.svg"
								alt="Clear Image"
								class="clear-btn"
								height="12"
								width="12"
							/>
							<!-- svelte-ignore a11y-img-redundant-alt -->
							<img
								src="https://homehardware.sirv.com/hh/icons/icon-footer-plus.svg"
								alt="User Image"
								height="16"
								width="16"
								class="plus"
							/>

							<input
								type="file"
								id={`photo-upload-${i}`}
								accept="image/*"
								name="photo"
								style="display: none;"
								on:change={showImage}
							/>
						</div>
					{/each}
				</div>
				{#if errors?.photo}
					<small class="ErrorNote">{errors.photo}</small>
				{/if}		
				<small>{en ? 'You cannot edit or delete media after submission.' : 'Vous ne pouvez pas modifier ou supprimer un média après l’avoir soumis.'}</small>
			</fieldset>
			<hr>
			<fieldset id="agreedtotermsandconditions">
				<label>
					<input type="checkbox" name="agreedtotermsandconditions" /> {en ? 'I agree to the terms & conditions' : 'J\'accepte les modalités d\'utilisation'}
				</label>
				{#if errors.agreedtotermsandconditions}
					<small class="ErrorNote">{errors.agreedtotermsandconditions}</small>
					{/if}
				<p>{en ? 'You may receive emails regarding this submission. Any emails will include the ability to opt-out of future communications.' : 'Vous recevrez peut-être des courriels relatifs à cette soumission. Vous pourrez choisir de refuser toute communication ultérieure dans chaque courriel.'}</p>
			</fieldset>

			<fieldset class="ButtonGroup">
				<button type="submit" class="Button ButtonBlock ButtonPrimary">{en ? 'Submit' : 'Soumettre'}</button>
				<button type="button" class="Button ButtonBlock ButtonSecondary" on:click|preventDefault={resetForm}>{en ? 'Cancel' : 'Annuler'}</button>	
			</fieldset>
		</form>
	{:else}
		<header>
			<h3 style="visibility: hidden;">{en ? 'Thank You' : 'Merci!'}</h3>
			<button class="Button ButtonGhost" on:click|preventDefault={closePanel}>{en ? 'Close' : 'Fermer'}</button>
		</header>
		<div class="submit-success-content">
			<h2>{en ? 'Thank You' : 'Merci!'}</h2>
			<p>{en ? 'Your review has been submitted.' : 'Votre évaluation a été soumise'}</p>
			<button class="Button ButtonPrimary ButtonHalfBlock" on:click|preventDefault={closePanel}>{en ? 'Continue Shopping' : 'Continuer à magasiner'}</button>
		</div>

		<!-- recently viewed products -->
		<div class="recently-viewed-container">
			{@html `<hh-product-recs cardstyle="vertical" type="recently-viewed"></hh-product-recs>`}
		</div>
	{/if}

</Portal>


<style>
	.product-name {
		margin-top: 1rem;
		font-size: 1.25rem;
	}
	.reviewstars {
		display: flex;
		flex-direction: row-reverse;
		justify-content: flex-end;
		gap: 0.25rem;
	}
	.reviewstars label {
		color: #e6e7e8;
		font-size: 1.75rem;
		line-height: 1;
		padding: .5rem .35rem .25rem .35rem;
		cursor: pointer;
		transition: color .3s;
		border: 3px solid #e6e7e8;
		border-radius: 6px;
		box-sizing: border-box;
		margin-left: 0 !important;
	}
	.reviewstars label:hover ~ label,
	.reviewstars label:hover {
		color:#d6001c;
	}
	.reviewstars label input {
		display: none !important;
		transform: none !important;
	}

	.overall-rating > div.container {
		display: flex;
		align-items: center;
		gap: 1rem;
		margin-top: 0.5rem;
	}
	.reviewstars label:has(input:checked),
	.reviewstars label:has(input:checked) ~ label {
		color: #fff;
		background: #d6001c;
		border-color: #d6001c;
	}

	fieldset textarea[name="reviewtext"] {
		height: 140px;
	}
	fieldset.recommendation {
		width: 100%;
	}
	fieldset.recommendation .btn-group {
		display: flex;
		gap: 0.5rem;
		justify-content: flex-end;
	}
	fieldset.fieldsetInline {
		display: grid;
		grid-template-columns: 0.3fr 0.7fr;
		gap: 1rem;
		flex-wrap: nowrap;
		padding-bottom: 0.8rem;
	}
	fieldset.fieldsetInline > label {
		padding-top: 0.6rem;
	}
	fieldset.fieldsetInline:has(label[for*="rating-set"]) {
		padding-bottom: 0.3rem;
	}
	fieldset.fieldsetInline > div {
		width: 100%;
	}
	input[hidden] {
		display: none !important;
	}
	.upload-boxes {
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
    }
    .upload-boxes > div {
        width: 150px;
        height: 150px;
        border: 2px dashed var(--hh-grey);
        border-radius: 8px;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    :global(.uploaded-image) {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .clear-btn {
        position: absolute;
        top: 4px;
        left: 4px;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        z-index: 10;
    }
	.ButtonGroup {
		width: 100%;
		padding-left: 2rem;
		padding-right: 2rem;
		justify-content: center;
	}
	.submit-success-content {
		display: grid;
		grid-template-columns: 1fr;
		place-items: center;
		margin-top: 2rem;
	}
	.submit-success-content button {
		margin-top: 1.5rem;
	}
</style>